import { isMobile } from 'react-device-detect'
import { CART_CONSTANTS, DIALOG_CONSTANTS } from '../actionTypes'
import {
	ANALYTICS_HELPER,
	CONSTANTS,
	HELPER,
	MANAGE_CART_HELPER,
	HISTORY,
	ROUTE_CONSTANTS,
	PRODUCT_HELPER,
} from '../../utils'
import { alertActions, configActions, metaAction, errorAction } from '../actions'
// import {
//     linkHandler,
// } from "../../hooks";
import { apiService } from '../../store/middleware/service'

export const cartActions = {
	TOGGLE_CART_ICON,
	setPhoneNumber,
	UPDATE_CART_LOCALE,
	SELECT_PRODUCT_ITEM,
	SELECT_PRODUCT_VARIANT,
	UN_SELECT_PRODUCT_ITEM,
	ADD_ITEM_TO_CART,
	UPDATE_CART,
	CLEAR_ITEMS_IN_CART,
	UPDATE_ITEM_QTY_TO_CART,
	UPDATE_CATEGORY_SELECTION,
	REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS,
	REMOVE_CART_ITEMS_FROM_CART,
	CREATE_ORDER,
	CLEAR_CART,
	PRODUCT_BUY_NOW_CLICKED,
}

function CLEAR_CART() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: CART_CONSTANTS.CLEAR_CART }
	}
}

function UPDATE_CART_LOCALE(cart_items) {
	return (dispatch) => {
		dispatch(request(cart_items))
	}
	function request(cart_items) {
		return { type: CART_CONSTANTS.UPDATE_CART_LOCALE_REQUEST, cart_items }
	}
}

function setPhoneNumber(requestData) {
	return (dispatch) => {
		dispatch(request(requestData))
	}
	function request(customer_details) {
		return { type: CART_CONSTANTS.PHONE_NUMBER_REQUEST, customer_details }
	}
}

function SELECT_PRODUCT_ITEM(product) {
	return (dispatch, getState) => {
		// grab current state
		const state = getState()
		const { showProductDetail } = state.action
		dispatch(request(product))
		if (!showProductDetail && isMobile) {
			// LOAD GTM EVENT
			ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.PRODUCT_DETAIL, {
				action: ANALYTICS_HELPER.EVENT.PRODUCT_DETAIL.OPEN.ACTION,
				label: ANALYTICS_HELPER.EVENT.PRODUCT_DETAIL.OPEN.LABEL,
				properties: {},
			})
			HISTORY.push(ROUTE_CONSTANTS.PRODUCT_DETAIL)
		}
		ANALYTICS_HELPER._productDetail(product)
		dispatch(metaAction.PRODUCT_DETAIL_SIDEBAR_OPEN())
	}
	function request(product) {
		return { type: CART_CONSTANTS.SELECT_PRODUCT_ITEM, product }
	}
}

function SELECT_PRODUCT_VARIANT(product, variant) {
	return (dispatch) => {
		ANALYTICS_HELPER._productClick(product, variant)
		dispatch(request(product, variant))
	}
	function request(product, variant) {
		return { type: CART_CONSTANTS.SELECT_PRODUCT_VARIANT, product, variant }
	}
}

function UN_SELECT_PRODUCT_ITEM(product) {
	return (dispatch) => {
		dispatch(request(product))
	}
	function request(product) {
		return { type: CART_CONSTANTS.UN_SELECT_PRODUCT_ITEM, product }
	}
}

function TOGGLE_CART_ICON() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: CART_CONSTANTS.CART_MENU_OPEN_REQUEST }
	}
}

function ADD_ITEM_TO_CART(product, quantity = 1, maximum_purchase_limit = false, show_msg) {
	return (dispatch, getState) => {
		// grab current state
		const state = getState()
		const { cart_items } = state.cart
		const { sub_total_amount } = cart_items
		const { selected_category } = state.inventory

		const max_quantity = PRODUCT_HELPER.PRODUCT_MAX_QUANTITY(product)
		if (max_quantity === 0) {
			return MANAGE_CART_HELPER.outOfStock()
		}

		if (!maximum_purchase_limit) {
			maximum_purchase_limit = state.inventory.inventory_settings?.maximum_purchase_limit
		}
		const total_amount = sub_total_amount + product?.selected_variant?.discounted_price * quantity
		let itemAdded = MANAGE_CART_HELPER.AddCartRule(
			maximum_purchase_limit,
			product.product_delivery_type,
			total_amount
		)
		if (!HELPER.isEmpty(product?.id) && itemAdded) {
			if (show_msg) {
				MANAGE_CART_HELPER.ShowAddToCardMsg(product)
			}
			ANALYTICS_HELPER._cartActions(product, quantity, selected_category)
			dispatch(request(product, quantity, selected_category))
		}
	}
	function request(cart_item, quantity, category) {
		return { type: CART_CONSTANTS.ADD_ITEM_TO_CART, cart_item, quantity, category }
	}
}

function UPDATE_ITEM_QTY_TO_CART(cart_items, addedItem, operation, quantity = null) {
	let cardItems = cart_items.items
	let subTotalAmount = cart_items.sub_total_amount
	let updatedCart = {
		cart_items: {},
		sub_total_amount: 0,
	}
	let itemAdded = true
	return (dispatch) => {
		let itemFound = cardItems.find((item) => {
			return (
				item.product.id === addedItem.id &&
				item.product.selected_variant.variant_id === addedItem.selected_variant.variant_id
			)
		})
		let indexFound = cardItems.findIndex((item) => {
			return (
				item.product.id === addedItem.id &&
				item.product.selected_variant.variant_id === addedItem.selected_variant.variant_id
			)
		})

		if (operation === CONSTANTS.SUB_QTY) {
			if (quantity === null) {
				quantity = itemFound.qty - 1
			}
			itemFound = subtractQty(itemFound, quantity)
			ANALYTICS_HELPER._cartActions(itemFound.product, 1, itemFound.category, operation)
		} else if (operation === CONSTANTS.DELETE_ITEM) {
			MANAGE_CART_HELPER.DeletedCartItemSuccessMsg(itemFound.product)
			const deletedItem = cardItems.filter(
				(item) =>
					item.product.id === itemFound.product.id &&
					item.product.selected_variant.variant_id === itemFound.product.selected_variant.variant_id
			)
			cardItems = cardItems.filter(
				(item) =>
					item.product.selected_variant.variant_id !==
					deletedItem[0].product.selected_variant.variant_id
			)
			//more variants not close sidebar
			let find_variants = cardItems.filter((item) => item.product.id === itemFound.product.id)
			if (find_variants?.length === 0) {
				dispatch(clear_added_product_item(itemFound.product))
				dispatch(cartActions.UN_SELECT_PRODUCT_ITEM(itemFound.product))
			}
			ANALYTICS_HELPER._cartActions(itemFound.product, itemFound.qty, itemFound.category, operation)
		} else {
			if (quantity === null) {
				quantity = itemFound.qty + 1
			}
			const addedQty = addQty(cardItems, itemFound, quantity)
			itemAdded = addedQty.itemAdded
			if (itemAdded) {
				itemFound = addedQty.itemFound
			}
		}

		if (operation !== CONSTANTS.DELETE_ITEM) {
			cardItems[indexFound] = itemFound
			//IF PRODUCT QUANTITY TURNS ZERO REMOVE ITEM FROM CART
			if (itemFound.qty === 0) {
				cardItems = cardItems.filter((item) => {
					return (
						item.product.id !== itemFound.product.id &&
						item.product.selected_variant.variant_id !==
							itemFound.product.selected_variant.variant_id
					)
				})
				dispatch(clear_added_product_item(itemFound.product))
			} else if (operation === CONSTANTS.SUB_QTY) {
				MANAGE_CART_HELPER.DeletedCartItemSuccessMsg(itemFound?.product)
			} else if (itemAdded) {
				MANAGE_CART_HELPER.ShowAddToCardMsg(itemFound?.product)
			}
		}
		subTotalAmount = 0
		cardItems.map((item) => {
			subTotalAmount += item.price
			return true
		})
		updatedCart.cart_items = cardItems
		updatedCart.sub_total_amount = subTotalAmount
		dispatch(request(updatedCart))
	}
	function request(cart) {
		return { type: CART_CONSTANTS.CHANGE_ITEM_QTY_IN_CART, cart }
	}
	function clear_added_product_item(product_removed) {
		return { type: CART_CONSTANTS.REMOVE_ITEM_FROM_PRODUCT_ITEM, product_removed }
	}
	function addQty(cardItems, itemFound, quantity) {
		let productQty = quantity
		const { selected_variant } = itemFound.product
		let productPrice = parseFloat(selected_variant.discounted_price) * productQty
		let subTotalAmount = 0
		subTotalAmount = cardItems.map((item) => {
			let amount = 0
			if (parseInt(item.product.id) === parseInt(itemFound.product.id)) {
				amount += productPrice
			} else {
				amount += item.price
			}
			return amount
		})
		const totalAmount = subTotalAmount.reduce(function (a, b) {
			return a + b
		}, 0)

		let itemAdded = MANAGE_CART_HELPER.AddCartRule(
			false,
			itemFound.product.product_delivery_type,
			totalAmount
		)
		if (itemAdded) {
			itemFound.qty = productQty
			itemFound.price = parseFloat(productPrice)
			ANALYTICS_HELPER._cartActions(
				itemFound.product,
				productQty,
				itemFound?.selected_category,
				CONSTANTS.ADD_QTY
			)
		}

		return { itemFound, itemAdded }
	}
	function subtractQty(itemFound, quantity) {
		const { selected_variant } = itemFound.product
		let productItemPrice = parseFloat(selected_variant.discounted_price)
		let productQty = quantity
		let productPrice = productItemPrice * productQty
		itemFound.qty = productQty
		itemFound.price = parseFloat(productPrice)
		return itemFound
	}
}

function PRODUCT_BUY_NOW_CLICKED() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: DIALOG_CONSTANTS.PRODUCT_BUY_NOW_CLICKED }
	}
}

function UPDATE_CART(product) {
	return (dispatch) => {
		let itemAdded = MANAGE_CART_HELPER.UpdateCartRule()
		if (itemAdded) {
			dispatch(request(product))
		}
	}
	function request() {
		return { type: CART_CONSTANTS.UPDATE_CART, payload: product }
	}
}

function CLEAR_ITEMS_IN_CART() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: CART_CONSTANTS.CLEAR_ITEMS_IN_CART }
	}
}

function REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: CART_CONSTANTS.REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS }
	}
}

function REMOVE_CART_ITEMS_FROM_CART(product) {
	return (dispatch) => {
		dispatch(request(product))
	}
	function request(product_removed) {
		return { type: CART_CONSTANTS.REMOVE_ITEM_FROM_PRODUCT_ITEM, product_removed }
	}
}

function UPDATE_CATEGORY_SELECTION(category, params) {
	const { productsPerPage } = params
	return (dispatch) => {
		const visibleProductParams = {
			category: category?.category,
			products: category?.products,
			productsPerPage,
			productsCurrentPage: 1,
		}
		dispatch(configActions.SET_CATALOG_VISIBLE_PRODUCT(visibleProductParams))
		dispatch(success(visibleProductParams))
	}
	function success(data) {
		return { type: CART_CONSTANTS.CHANGE_CATEGORY_SUCCESS, response: data }
	}
}

function CREATE_ORDER(data) {
	return (dispatch) => {
		let requestData = data
		let items = data?.cart_items?.items
		ANALYTICS_HELPER._productPurchase(data?.cart_items)
		const cartItems = items.map((item) => {
			const itemAttributes = item?.product?.selected_variant?.attributes
			let attributes = []
			if (!HELPER.isEmpty(itemAttributes)) {
				attributes = []
				itemAttributes.map((itemAttribute) => {
					attributes.push({
						attribute_id: itemAttribute.id,
						option_id: itemAttribute.options?.id,
						option_value: itemAttribute.options?.option_value,
					})
					return true
				})
			}
			return {
				product_id: String(item?.product.id),
				variant_id: String(item?.product?.selected_variant?.variant_id),
				quantity: item?.qty,
				product_attributes: attributes,
			}
		})
		requestData.cart_items = cartItems

		dispatch(request())
		apiService
			.createOrder(requestData)
			.then((response) => {
				const responseStatus = response?.status
				if (!HELPER.isEmpty(responseStatus) && responseStatus === CONSTANTS.HTTP_RESPONSE.SUCCESS) {
					let responseData = response?.data
					let checkoutUrl = responseData?.body?.checkout_url
					dispatch(success(responseData))
					if (!HELPER.isEmpty(checkoutUrl)) {
						HELPER.REDIRECT_TO_PATH(checkoutUrl)
					}
				}
			})
			.catch((error) => {
				const error_response = error?.response
				const error_message = errorAction(error_response)
				const errorBody = error_response?.data?.body
				dispatch(failure(errorBody))
				dispatch(alertActions.warning(error_message?.message, CONSTANTS.ERROR_TYPE.TOAST))
			})
	}

	function request() {
		return { type: CART_CONSTANTS.CREATE_CATALOG_ORDER_REQUEST }
	}
	function success(response) {
		return {
			type: CART_CONSTANTS.CREATE_CATALOG_ORDER_SUCCESS,
			response,
		}
	}
	function failure(error_body) {
		return { type: CART_CONSTANTS.CREATE_CATALOG_ORDER_FAILURE, response: error_body }
	}
}
